/* eslint-disable no-unused-vars */
import DataTable from '@/containers/data_table_ml/DataTable';
import styles from './TablePage.less?modules';
import ButtonML from '@/components/button_ml/ButtonML';
import Popconfirm from '@/containers/popconfirm/Popconfirm';
// import { CONSTANT } from '../../constant/index';
import SingInputML from '@/components/input_all_ml/form_sing_input_ml/SingInputML';
import SelectML from '@/components/select_ml/SelectML';
import React, { useState, useCallback, useEffect } from 'react';
import { toOption } from '@/utils/comUtil.js';
import ModalML from '@/components/modal_ml/ModalML';
import { useTrigger } from '@/utils/comHook.js';
import Fop from 'PAGES/bre/_comm/containers/filter_out_put';
import { useDispatch, useSelector } from 'dva';
import { history } from 'umi';
import Cascader from '@/containers/cascader_ml/cascader_package_ml/CascaderPackage';

const TablePage = (props) => {
  const dispatch = useDispatch();

  const {
    loadingstatus,
    edit,
    pushLog,
    pushDecisionGraphMap,
    tableData,
    form,
  } = props || {};
  const handleMemberDelete = (record) => {
    props.deleteItem(record);
  };
  const trigger = useTrigger();
  const [curentRecord, setCurentRecord] = useState(''); //当前改变的record
  const [tabelD, setTabelD] = useState([]);
  const [addOptions, setAddOptions] = useState([]);
  const [cascaderData, setCascaderData] = useState({});

  // const goToModal = (recor) => {
  //   console.log(recor);
  // };
  const openFilterModal = (record, first) => {
    trigger.open();
    setCurentRecord(record.id);
  };

  const changeOptions = (list) => {
    const { fieldName, variableName: ids } = list && list.length ? list[0] : {};
    let tabelDCopy = JSON.parse(JSON.stringify(tabelD));
    //只能选一个，因为如果选多个的话就要挂载在每个table上，挂载一个选择数组。目前仅支持单个挂载
    (tabelDCopy || []).forEach((item) => {
      if (item.id === curentRecord) {
        item['outputItem'] = ids;
        item['nodeBlockId'] = fieldName;
      }
    });
    setTabelD(tabelDCopy);
  };
  //节点名称
  const handleClick = (record) => {
    dispatch({
      type: 'dgic/getItemNodeSelect',
      payload: {
        values: {
          nodeId: history.location.query.nodeId,
          nodeBlockId: record.nodeBlockId,
        },
      },
    });
  };
  const columns = [
    {
      title: 'ID',
      dataIndex: 'id',
      key: 'id',
      width: 40,
    },
    {
      title: '入参',
      dataIndex: 'inputItem',
      key: 'inputItem',
      width: 60,
    },
    {
      title: '默认值',
      dataIndex: 'defaultValue',
      key: 'defaultValue',
      width: 150,
      render: (text, record) => {
        return (
          <SingInputML
            height="37px"
            labelwidth="0px"
            inputWidth="100px"
            // labelVal="规则包名"
            placeVal="请输入值"
            className="no_label"
            name={'defaultValue-' + record.id}
            value={text}
            // allowClear={true}
          />
        );
      },
    },
    {
      title: '出参配置',
      dataIndex: 'outputItem',
      key: 'outputItem',
      width: 150,
      render: (text, record) => {
        let opt = {};
        opt[record.nodeBlockId] = record.outputItem;
        return (
          <div className={styles.seled_filter}>
            {/* <SelectML
              height="37px"
              labelwidth="130px"
              inputWidth="180px"
              placeVal="请选择"
              name={'outputItem-' + record.id}
              // allowClear={true}
              className={['no_label']}
              option={toOption(opt)}
              value={record.outputItem}
              require={[
                {
                  required: true,
                  message: '请选择规则包状态',
                },
              ]}
            />
            <div
              className={styles.seled_filter_add}
              onClick={() => {
                openFilterModal(record);
              }}
            >
              <span>+</span>
            </div> */}
            <Cascader
              // labelVal={item.label}
              height="37px"
              // labelwidth="130px"
              onChange={() => {
                // getValue(item.onChange);
              }}
              options={addOptions}
              allowClear={true}
              placeVal={'请输入'}
              name={'outputItem-' + record.id}
              value={(() => {
                for (const key in cascaderData) {
                  if (record.outputItem === key) {
                    return cascaderData[key];
                  }
                }
              })()}
              form={form}
              className={['mt']}
              require={[
                {
                  required: true,
                  message: '请选择规则包状态',
                },
              ]}
            />
          </div>
        );
      },
    },
    {
      title: '节点名称',
      dataIndex: 'nodeName',
      key: 'nodeName',
      width: 150,
      render: (text, record) => {
        return (
          <SelectML
            height="37px"
            labelwidth="130px"
            inputWidth="180px"
            className={['no_label']}
            placeVal="请选择"
            name={'nodeName-' + record.id}
            value={text}
            // option={toOption(tvfRuleTypeMap)}
            require={[
              {
                required: true,
                message: '请选择规则包状态',
              },
            ]}
            onClick={() => handleClick(record)}
          />
        );
      },
    },
    {
      title: '包类名',
      dataIndex: 'endNode',
      key: 'endNode',
      width: 60,
    },
    {
      title: '包名称',
      dataIndex: 'nodeBlockName',
      key: 'nodeBlockName',
      width: 120,
    },
    {
      title: '输入项名称',
      dataIndex: 'outputItem',
      key: 'outputItem',
      width: 120,
    },
    {
      title: '字段类型',
      dataIndex: 'fieldType',
      key: 'fieldType',
      width: 180,
    },
  ];
  const fetchTabelData = useCallback(() => {
    setTabelD([...tableData]);
  }, [tableData]);
  useEffect(() => {
    fetchTabelData();
  }, [fetchTabelData]);

  // 获取级联下拉数据
  const fetchPackageData = useCallback(() => {
    dispatch({
      type: 'bre/getAllPackages',
      payload: {},
      callback: (res) => {
        let result = [];
        let cascaderDataUnuse = {};
        console.log(res);
        res &&
          res.length > 0 &&
          res.forEach((item) => {
            let child = [];
            item.fields &&
              item.fields.forEach((item2) => {
                child.push({
                  // value: item2.id,
                  value: item2.variableName,
                  label: item2.variableName,
                });
                cascaderDataUnuse[item2.variableName] = [
                  item.fieldPackageId,
                  item2.variableName,
                ];
              });
            result.push({
              value: item.fieldPackageId,
              label: item.fieldPackageName,
              children: child,
            });
          });
        setCascaderData(cascaderDataUnuse);
        setAddOptions(result);
      },
    });
  }, [dispatch]);

  // 发起请求
  useEffect(() => {
    fetchPackageData();
  }, [fetchPackageData]);

  return (
    <>
      <DataTable
        className="demo-test"
        style={{ minWidth: '1547px' }}
        columns={columns}
        rowSelection={false}
        // pagination={pagination}
        scroll={{ y: 'calc(100vh - 156px - 3rem)' }}
        loading={loadingstatus}
        dataSource={tabelD}
        changePage={(a) => {
          props.pageNumChange(a);
        }}
        changePageSize={(a) => {
          props.pageSizeChange(a);
        }}
      />
      <ModalML
        title=""
        handleOk={trigger.open}
        handleCancel={trigger.close}
        visible={trigger.visible}
      >
        <Fop handleCancel={trigger.close} changeOptions={changeOptions} />
      </ModalML>
    </>
  );
};
export default TablePage;
